const SET_JOB_SEARCH = "SET_JOB_SEARCH";

const initialState = {
  jobs: [],
};

const JobReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_JOB_SEARCH:
      return { ...state, jobs: [...action.payload] };
    default:
      return state;
  }
};

export const setJobSearch = (jobs) => {
  return {
    type: SET_JOB_SEARCH,
    payload: jobs,
  };
};

export default JobReducer;
